import { render, staticRenderFns } from "./OrderTrackingUploader.vue?vue&type=template&id=b2acf44e"
import script from "./OrderTrackingUploader.vue?vue&type=script&lang=js"
export * from "./OrderTrackingUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports